const injectMessage = (msg, data = {}) => {
  const {
    pickupCutOffTimeFormatted, otherDate, deliveryDay, bossAvailabilityLabel, sddCutoffTime, eGiftCardShipHours, eGiftCardEmailId,
  } = data;
  let newMsg = msg;
  if (pickupCutOffTimeFormatted) newMsg = newMsg.replace('__CUTOFF__', pickupCutOffTimeFormatted);
  if (otherDate) newMsg = newMsg.replace('__OTHERDATE__', otherDate);
  if (deliveryDay) newMsg = newMsg.replace('__DAY__', deliveryDay);
  if (bossAvailabilityLabel) newMsg = newMsg.replace('__BOSSDATE__', bossAvailabilityLabel);
  if (sddCutoffTime) newMsg = newMsg.replace('__CUTOFF__', sddCutoffTime);
  if (eGiftCardShipHours) newMsg = newMsg.replace('__TIME__', eGiftCardShipHours);
  if (eGiftCardEmailId) newMsg = newMsg.replace('__EMAIL__', eGiftCardEmailId);
  return newMsg;
};

export default injectMessage;
